module.exports = __webpack_public_path__ + "static/media/house-return.20747b14.svg";